// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__3QKkT","primary":"styles_primary__iEqaq","secondaryLight":"styles_secondaryLight__3WMo7"};